import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'creditNoteStatus'
})
export class CreditNoteStatusPipe implements PipeTransform {

  private map: Record<string, { label: string; class: string }> = {
    draft:             { label: 'Draft',                class: 'chip-cn-draft' },
    pending:           { label: 'Awaiting Approval',    class: 'chip-cn-pending' },
    approved:          { label: 'Awaiting Verification', class: 'chip-cn-approved' },
    verified:          { label: 'Verified',             class: 'chip-cn-verified' },
    applied:           { label: 'Applied',              class: 'chip-cn-applied' },
    partially_applied: { label: 'Partially Applied',    class: 'chip-cn-partial' },
    cancelled:         { label: 'Cancelled',            class: 'chip-cn-cancelled' },
  };

  transform(value: string, type: 'label' | 'class'): string {
    const key = (value ?? '').toLowerCase();
    return this.map[key]?.[type] ?? '';
  }

}
